import { Note } from './BriefSectionTypes'

export const formatThousands = (value: number): string => Math.trunc(value).toLocaleString('en-US')

/* A whole-number money amount. The currency is free text on the profile, so a recognised code (AUD, eur) is
   formatted properly, and anything else (a symbol like $ or €, or a local name) is put in front as written. */
export const formatMoney = (value: number, currency?: string): string => {
  const code = (currency || '').trim()
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: code || 'USD',
      maximumFractionDigits: 0,
    }).format(value)
  } catch {
    const amount = value.toLocaleString('en-US', { maximumFractionDigits: 0 })
    if (!code) return amount
    return /^[^\p{L}]+$/u.test(code) ? `${code}${amount}` : `${code} ${amount}`
  }
}

export const findNote = <T extends { id: string; notes?: Note[] }>(
  sections: T[],
  sectionId: string,
  noteId: string
): Note | undefined => sections.find(section => section.id === sectionId)?.notes?.find(note => note.id === noteId)
